<script>
import VSelect from 'Components/global/form/VSelect.vue';
import { http } from '@/system/http';
import { toRaw } from 'vue';

export default {
    components: {
        VSelect,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        value: {
            required: false,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        showOnlyNprTreatmentTypes: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            treatmentTypes: [],
            loading: false,
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            const url = this.showOnlyNprTreatmentTypes ?
                '/app/treatment-types/norwegian-patient-registry' : '/app/treatment-types';

            this.loading = true;
            http.get(url)
                .then((response) => {
                    this.treatmentTypes = [
                        // We still want to support the default (vanilla) treatment type. Id '0' would become null,
                        // which in turn would become `provider` with a value of `null`. This indicates regular treatment.
                        {id: 0, description: trans('apps.treatments.default_treatment_type')},
                        ...(Array.isArray(response.data) ? response.data : [])
                    ];
                    this.$emit('loaded');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onInput(valueString) {
            // `VSelect` always returns the selected option as a string. We know that we always have an integer id.
            const valueInt = parseInt(valueString);
            if (isNaN(valueInt)) {
                throw new Error('Assertion Failed: Got "' + valueString+ '", but we expect a valid integer');
            }

            // Convert the placeholder value to null, so we don't need to handle null or 0 all over the place.
            if (valueInt === 0) {
                return null;
            }

            const selectedTreatmentType = this.treatmentTypes.find((treatmentType) => treatmentType.id === valueInt);
            if (!selectedTreatmentType) {
                throw new Error('Assertion Failed: No treatment type with id "' + valueInt + '" found');
            }

            this.$emit('input', valueInt);
            this.$emit('change', structuredClone(toRaw(selectedTreatmentType)));
        },
    },
}
</script>

<template>
    <VSelect
        :id="id"
        :name="id"
        valueKey="id"
        label="description"
        :options="treatmentTypes"
        :useNativePlaceholder="true"
        :placeholder="trans('apps.treatments.select_treatment_type')"
        :value="value"
        :required="required"
        :disabled="loading"
        @input="onInput"
    />
</template>

<style scoped>
</style>
